export default (obj) => {
    var data = {
        type_id: []
    };

    if (typeof obj === 'object' && obj != null) {
        data = $.extend(data, obj);
    }

    $('[data-speaker] [name="type_id"]:checked').each(function () {
        data.type_id.push($(this).val());
    });

    if ($('[data-speaker] [name="industry_id"]:checked').length) {
        data.industry_id = $('[data-speaker] [name="industry_id"]:checked').val();
    } else {
        data.industry_id = $('[data-speaker] [name="industry_id"]').val();
    }

    data.name = $('[data-speaker] [name="name"]').val();

    return data;
}